<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center">This novel is dedicated to my son, Harrison, in the hope that he seeks out and embraces new challenges, adventures, and goals throughout his life.</p>
<p class="center"><img alt="" src="OEBPS/images/3.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/4.jpg"/></p>
<p class="center"><img alt="" src="OEBPS/images/5.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?fb83a784